import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { CAS3_PROVIDERS_ENDPOINT, getAllCas3ProvidersKey } from "./useGetAllCas3Providers";

type UpsertCas3ProviderOptions = {
    id?: number;
    payload: Record<string, unknown>;
};

export const useUpsertCas3Provider = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async ({ id, payload }: UpsertCas3ProviderOptions) => {
            if (id === undefined) {
                return loggedInApiCall.post(CAS3_PROVIDERS_ENDPOINT, payload);
            }

            return loggedInApiCall.patch(`${CAS3_PROVIDERS_ENDPOINT}/${id}`, payload, {
                headers: { "Content-Type": "application/merge-patch+json" },
            });
        },
        onSuccess: () => queryClient.invalidateQueries([getAllCas3ProvidersKey]),
    });

    return query;
};
